import { brandSwitcherEnabled, readBrandOverride } from './override';
import { brands } from './registry';
import { resolveBrandKey } from './resolveBrandKey';

export { brands } from './registry';
export { brandList, brandSwitcherEnabled, setBrandOverride } from './override';

export const brand =
  brands[
    resolveBrandKey({
      override: readBrandOverride(),
      envBrand: import.meta.env.VITE_BRAND,
      appType: import.meta.env.VITE_APP_TYPE,
      switcherEnabled: brandSwitcherEnabled,
    })
  ];
